import React from 'react'
import Report from '../Report/Report'
import './FormMachine.sass'

export default props => {


  return (

    <React.Fragment>

      <main className="params">

        <h1 className="params__title">
          Плоскошлифовальный станок с вертикальным шпинделем
        </h1>

        <div className="params-content">

          <div className="method-typebox">
            <h2 className="method-typebox__title">Модель станка</h2>

            <div className="method-type-wrapper">
              {props.unenableButtons
                ? null
                : <div className="method-link">
                    <button onClick={() => props.prevPage()} className="mode-link__prev method-wrapper__link method__next form-button">
                    </button>
                  </div>
              }

              <div className="method-typebox__type">{props.machine}</div>

              {props.unenableButtons
                ? null
                : <div className="method-link">
                    <button onClick={() => props.firstNext()} className="mode-link__next method-wrapper__link method__prev form-button">
                    </button>
                  </div>
              }

            </div>

          </div>

          <div className="params-content-descr mode-center">

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Форма круга</span>
              <span className="params-label__value road-input__value mode-input__value">ЧЦ</span>

            </div>

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Диаметр круга</span>
              <span className="params-label__value road-input__value mode-input__value">300</span>

            </div>

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Скорость круга, м/с</span>
              <span className="params-label__value road-input__value mode-input__value">{props.speed}</span>

            </div>

            <div className="params-label second-input road-input form-input">

              <span className="params-label__item road-input__item mode-input__item form-input__item">
                Габариты рабочего пространства:
                Lmax x Bmax, мм
              </span>

              <span className="form-size">

                <span className="params-label__value form-size__value">{props.length}</span>

                X

                <span className="params-label__value form-size__value">{props.width}</span>

              </span>

            </div>

            <div className="params-label second-input road-input form-input">

              <span className="params-label__item road-input__item mode-input__item form-input__item">
                Диапазон скоростей стола, м/мин
              </span>

              <span className="form-size">

                <span className="params-label__value form-size__value">3</span>

                X

                <span className="params-label__value form-size__value">{props.maxMinutes}</span>

              </span>

            </div>

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Мощность привода главного движения кВт</span>
              <span className="params-label__value road-input__value mode-input__value">22</span>

            </div>

          </div>

        </div>

      </main>

      <Report/>

    </React.Fragment>

  )

}